<template>
    <div class="header">
        <div>
            <img src="@/assets/img/logo.png" class="logo" /> 
            <span>全场景编辑器</span> 
        </div>
        <div>
            <span @click.stop="save(0)"><i class="iconfont iconbaocun"></i> 保存 </span>
            <span @click.stop="save(1)"><i class="iconfont iconlingcunwei"></i> 另存为 </span>
            <span @click.stop="save(2)"><i class="iconfont iconfabu"></i> 发布并分享 </span>
            <span @click.stop="save(3)"><i class="iconfont iconyulan"></i> 预览 </span>
            <span @click.stop="exit"><i class="iconfont icontuichu"></i> 退出</span>
        </div>
        <div class="toast" v-show="showToast">
            <div class="head"><span @click.stop="showToast = false" class="back"><i class="iconfont iconfanhui"></i> 返回</span></div>
            <i class="iconfont icontick"></i>
            <p>发布成功</p>
            <p>前往 <a :href="worksUrl" target="_blank">我的作品</a> 进行作品管理</p>
            <div class="b">
                <span>分享链接</span>
                <div>{{shareUrl}}</div>
                <button @click.stop="copy" ref="btn" :data-clipboard-text="shareUrl">复制</button>
            </div>
            <div class="block"></div>
        </div>
    </div>
</template>

<script>
import { ResponseCode } from "@/utils/axios";
import BusEvent from "@/busEvent"
import Cookie from "js-cookie"
import ClipboardJS from 'clipboard'

export default {

    data(){
        return {
            mapLoaded: false,
            shareUrl: '',
            worksUrl: '',
            showToast: false
        }
    },

    props: {
        sceneData: {
            default: {}
        }
    },

    computed: {

        billBoard(){
            return this.viewer.billboard
        },

        billBoard2(){
            return this.viewer.billboard2
        },

        viewer(){
            return window.viewer
        }
    },

    mounted(){
        this.$notify({
            title: '提示',
            type: 'success',
            position: 'bottom-left',
            message: '鼠标左键单击选中模型，单击其他区域取消选中',
            duration: 5000
        })
        window.addEventListener( 'click', this.verifyLogin )
        this.$bus.$on( BusEvent.MapLoaded, () => {
            this.mapLoaded = true
        })
        new ClipboardJS(this.$refs.btn)
        this.worksUrl = location.origin + '/workbench/myWorks'
    },

    beforeDestroy(){
        window.removeEventListener( 'click', this.verifyLogin )
    },

    methods: {
        /**
         * 保存
         */
        save( status ){
            if( !this.mapLoaded ) return
            this.$mr_confirm( status == 1 ? '是否将该作品复制保存为另一个作品？' : '是否保存当前场景？', () => {
                let data = Object.create(null)
                var modelDatas = this.viewer.resourceManager.export()
                data.modelDatas = JSON.stringify( modelDatas )
                data.cameraData = JSON.stringify( this.viewer.gisManager.defaultView )
                data.measuredData = JSON.stringify( this.viewer.mapMeasure.saveToJSON() )
                if( this.viewer.mapFlyEditor ){
                    data.flightData = JSON.stringify( this.viewer.mapFlyEditor.saveToJSON() )
                }else{
                    data.flightData = JSON.stringify( this.$parent.flyData || [] )
                }
                data.informationCards = JSON.stringify( this.billBoard.export() )
                data.hotspotData = JSON.stringify( this.billBoard2.export() )
                data.effectData = this.exportEffect()
                //保存名称、封面等信息
                data = Object.assign( data, this.$parent.$refs.menu.modelInfo )
                data.userId = Cookie.get('loginId')
                data.id = this.$route.query.id || ''
                if( status === 1 ){
                    delete data.id
                    data.name = data.name + '-副本'
                }
                if( status == 2 ){
                    data.released = true
                }
                this.axios.post( '/api-application/fullSceneEditor/saveOrUpdate', data ).then(res => {
                    if( res.resp_code == ResponseCode.SUCCESS ){
                        if( status == 3 ){
                            window.open( `/3d/preview?id=${res.datas}` )
                            this.$router.replace({ path: `/editor?id=${res.datas}` })
                            location.reload()
                        }
                        if( status == 2 ){
                            this.shareUrl = location.origin + `/3d/preview?id=${res.datas}`
                            this.showToast = true
                        }
                        if( status == 1 ){
                            this.$router.replace({ path: `/editor?id=${res.datas}` })
                            location.reload()
                        }
                        if( status == 0 ){
                            this.$router.replace({ path: `/editor?id=${res.datas}` })
                            location.reload()
                        }
                    }else{
                        this.$message.warning( res.resp_msg )
                    }
                })
            }, () => {})
        },

        /**
         * 退出编辑器
         */
        exit(){
            this.$mr_confirm( '确认退出吗？', () => {
                window.opener = null
                window.open('_blank','_self')
                window.close()
            })
        },

        /**
         * 校验用户是否登陆
         */
        verifyLogin(){
            if( !this.$store.state.login.loginId || !Cookie.get('loginId') ){
                this.$root.loginVisible = true
            }
        },

        /**
         * 导出特效
         */
        exportEffect(){
            const arr = this.viewer.root.children.filter(item => item.isEffect)
            const effectData = arr.map( item => {
                switch ( item.effectType ) {
                    case 'flame':
                        return{
                            type: item.effectType,
                            size: item.size,
                            position: item.position.toArray()
                        }
                        break;
                    case 'snow':
                        return{
                            type: item.effectType,
                            density: item.density
                        }
                        break;
                    case 'rain':
                        return{
                            type: item.effectType,
                            density: item.density
                        }
                        break;
                    default:
                        break;
                }
            })
            return JSON.stringify( effectData )
        },

        copy(){
            this.$message.success('链接复制成功')
        }
    }
}


</script>

<style lang="scss" scoped>
.header{
    background-color: #1458EA; height: 60px; display: flex; justify-content: space-between; align-items: center;
    >div:nth-child(1){
        display: flex; align-items: center; height: 100%;
        img{ width: 91px; height: 29px; padding: 0 20px; border-right: 1px solid rgba(255,255,255,0.2); margin-right: 10px; }
        span{ font-size: 18px; color: #FFF; }
    }
    >div:nth-child(2){
        display: flex; align-items: center; height: 100%;
        span{
            .iconfont{ font-size: 18px; margin: 0 3px; }
            color: #FFF; padding: 0 20px; border-right: 1px solid rgba(255,255,255,0.2); font-size: 14px; cursor: pointer; 
        }
    }
}
.toast{
    width: 384px; height: 100vh; position: fixed; z-index: 10; background-color: #F2F4F6; right: 0; top: 0; display: flex; flex-direction: column; align-items: center;
    .icontick{ margin-top: 100px; font-size: 60px; color: #1458EA; }
    .head{height: 60px; width: 100%; background-color: #1458EA; position: relative;}
    .back{ .iconfont{ font-size: 20px; margin-right: 5px; } font-size: 14px; position: absolute; right: 20px; top: 16px; cursor: pointer; margin-top: 0; color: #FFF; }
    >p{margin-top: 20px; color: #182C49;}
    a{ color: #1458EA; text-decoration: none; }
    .b{
        margin-top: 50px; display: flex; width: 100%; height: 50px; align-items: center; justify-content: center;
        >div{background-color: #fff; padding: 0 10px; height: 40px; line-height: 40px; text-overflow: ellipsis; border-radius: 5px; width: 190px; overflow: hidden; margin: 0 10px; }
        button{ padding: 10px 20px; background-color: #1458EA; color: #FFF; border-radius: 5px; cursor: pointer;}
        span{ color: #777777; }
        
    }
    .block{ width: 200px; height: 60px; background-color: #1458EA; position: absolute; top: 0; left: -200px; }
}
</style>